import React from 'react';
import {observer} from "mobx-react";
import {DomainNs} from "../../Types/DomainNs";
import TooltipV1 from "../TooltipV1/TooltipV1";
import LinkV1 from "../LinkV1/LinkV1";

type CharacterListValueV1Props = {
    value: number | string | DomainNs.CharacterFieldValueInterface[]
    unit: string | null
    className: string
}

const CharacterListValueV1 = observer((props: CharacterListValueV1Props) => {
    const {value, unit, className} = props;

    if (Array.isArray(value)) {
        return (
                <div className={className}>
                    {value.map((v, k) => (
                        <span key={k}>
                            {/*{v.href}*/}
                            <LinkV1 href="#" label={v.value}></LinkV1>
                            <>&nbsp;</>
                            <TooltipV1 content={v.tooltip} />
                            {k < value.length - 1 && <>,&nbsp;</>}
                        </span>
                    ))}

                </div>
        );
    }

    return (
            <div className={className}>
                {value}{unit ? ` ${unit}` : ''}
            </div>
    );
});

export {CharacterListValueV1}

